import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(err => err)
}
const routerReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return routerReplace.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/index',
    meta: {
      title: ''
    },
    children: [{
      path: '/index',
      name: '主页',
      component: () => import('@/views/Index'),
      meta: {
        title: '主页',
        componentName: 'Index'
      }
    }]
  }
]

const router = new VueRouter({
  routes: routes
})

export default router
